export const FILE_FORM_SET_FILES = 'FILE_FORM_SET_FILES';
export const FILE_FORM_SET_URLS = 'FILE_FORM_SET_URLS';
export const FILE_FORM_CLEAR = 'FILE_FORM_CLEAR';

export const fileFormSetFiles = files => ({
    type: FILE_FORM_SET_FILES,
    payload: files
});

export const fileFormSetUrls = urls => ({
    type: FILE_FORM_SET_URLS,
    payload: urls
});

export const fileFormClear = () => ({
    type: FILE_FORM_CLEAR,
})
